import { createContext, useContext, useState, useEffect, ReactNode } from 'react';

export interface BirthInfo {
  name?: string;
  birthDate: string;
  birthTime: string;
  birthPlace: string;
  gender: 'male' | 'female';
}

interface BirthInfoContextType {
  birthInfo: BirthInfo | null;
  setBirthInfo: (info: BirthInfo) => void;
  clearBirthInfo: () => void;
}

const BirthInfoContext = createContext<BirthInfoContextType | undefined>(undefined);

export function BirthInfoProvider({ children }: { children: ReactNode }) {
  const [birthInfo, setBirthInfoState] = useState<BirthInfo | null>(() => {
    const stored = localStorage.getItem('birthInfo');
    return stored ? JSON.parse(stored) : null;
  });

  const setBirthInfo = (info: BirthInfo) => {
    setBirthInfoState(info);
    localStorage.setItem('birthInfo', JSON.stringify(info));
  };

  const clearBirthInfo = () => {
    setBirthInfoState(null);
    localStorage.removeItem('birthInfo');
  };

  return (
    <BirthInfoContext.Provider value={{ birthInfo, setBirthInfo, clearBirthInfo }}>
      {children}
    </BirthInfoContext.Provider>
  );
}

export function useBirthInfo() {
  const context = useContext(BirthInfoContext);
  if (context === undefined) {
    throw new Error('useBirthInfo must be used within a BirthInfoProvider');
  }
  return context;
}